import { Directive } from '@angular/core'
import { Subscription } from 'rxjs'
import { Router } from '@angular/router'
import { filter, skip, tap } from 'rxjs/operators'
import { isNotNullable } from '@spartacus/core'
import { MbConstants } from '../../../shared/mb-constants'
import { MbCheckoutReviewInfoType, MbCheckoutTypes, MbOrderType } from '../../../models'
import { MbSpinnerService } from '../../../shared/services/mb-spinner.service'
import { Order } from '@spartacus/order/root'
import { OrderEntry } from '@spartacus/cart/base/root'
import { OrderHistoryService } from '@spartacus/order/core'

@Directive()
export abstract class MbCheckoutConfirmationBaseComponent {

  order$ = this.orderService.getOrderDetails().pipe(
    filter(isNotNullable),
    skip(1),
    tap(order => {
      this.mbSpinnerService?.clearMbSpinner()
      if (!Object.keys(order)?.length) {
        this.router.navigate(['/not-found']).catch(error => console.error(error))
      } else {
        this.order = order
        this.orderEntries = [...order?.entries || []].sort((a, b) => (a.entryNumber || 0) - (b.entryNumber || 0))
        this.currentOrderType = this.getOrderType()
        const checkoutType = order?.checkoutStatus?.checkoutType
        if (checkoutType === this.checkoutTypes.CHECKOUT_TYPE_D || checkoutType === this.checkoutTypes.CHECKOUT_TYPE_E) {
          this.isPurchaseCheckoutType = true
        }
      }
    })
  )
  order: Order | undefined
  orderEntries: OrderEntry[] | undefined
  infoTypes = MbCheckoutReviewInfoType
  orderType = MbOrderType
  currentOrderType: string | undefined
  subscription = new Subscription()
  isPurchaseCheckoutType = false
  checkoutTypes = MbCheckoutTypes
  constants = MbConstants

  constructor (protected orderService: OrderHistoryService,
               protected router: Router,
               protected mbSpinnerService?: MbSpinnerService) {
  }

  navigateToHome () {
    return this.router.navigate(['/products/all-product-categories.html'])
  }

  getOrderType () {
    const entries = [...this.order?.entries || []].sort((a, b) => (a.entryNumber || 0) - (b.entryNumber || 0))
    const isRequest = entries?.some(
      (entry: any) => entry?.orderEntryType === this.constants.PRICE_REQUEST || entry?.orderEntryType === this.constants.PRICE_MIX) || false
    const isOrder = entries?.some((entry: any) => entry?.orderEntryType === this.constants.PRICE_AVAILABLE) || false

    if (isRequest && isOrder) {
      return this.orderType.MIXED
    } else if (isRequest && !isOrder) {
      return this.orderType.REQUEST
    } else if (!isRequest && isOrder) {
      return this.orderType.ORDER
    }
    return this.orderType.ORDER
  }
}
